import SectionTitle from "../layout/SectionTitle";
import { useInView } from "react-intersection-observer";
import { useTranslation } from 'react-i18next';
import ProjectsDisplay from "../layout/ProjectsDisplay";
import { getRealEstatePrograms } from "../../data/realEstatePrograms";

export default function ProjetsSection() {
  const { t } = useTranslation();
  const [sectionRef] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  
  // Récupérer les programmes immobiliers
  const allProjects = getRealEstatePrograms(t);

  return (
    <section className="py-8 bg-gray-50" ref={sectionRef}>
      <div className="container mx-auto px-4">
        <div className="mb-10">
          <SectionTitle
            overline={t('projects.title')}
            highlight={t('projects.highlight')}
            showLogo={true}
            align="left"
          />
        </div>
        
        <ProjectsDisplay 
          projects={allProjects} 
          showMoreButton={true}
          initialCount={3}
        />
      </div>
    </section>
  );
}
